export default __webpack_public_path__ + "static/media/killer_whale.00602468.png";